import {Injectable} from '@angular/core';
import {isArray, forEach} from 'lodash';

@Injectable()
export class AutocompleteService {

    buildSuggestionEngine(optionsGetter: Function, suggestionParser: Function, sourceListener: Function): Object {
        return (query, callback) => {
            var matches;

            // an array that will be populated with substring matches
            matches = [];

            // regex used to determine if a string contains the substring `q`
            let substrRegex = new RegExp(query, 'i');

            let source = optionsGetter();
            sourceListener(source);

            // iterate through the pool of strings and for any string that
            // contains the substring `q`, add it to the `matches` array
            if (!isArray(source)) {
                return;
            }
            forEach(source.map(item=>suggestionParser(item)), function (str) {
                if (substrRegex.test(str)) {
                    matches.push(str);
                }
            });

            callback(matches);
        };
    };
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/autocomplete/autocomplete.service.ts